import React from 'react';
import { ComingSoon } from '../ComingSoon';

export const Privacy = () => {
  return <ComingSoon title="Privacy Policy" />;
};
